import React from "react";
import { Button } from "react-bootstrap";

function ClinicalData() {

    return (
        <div style={{ padding: "30px" }}>
            <h2>Clinical Data</h2>


           
            <Button
                type="submit"
                className="px-4"
                style={{
                    position: "absolute",
                    bottom: "100px",
                    right: "50px",
                    width: "200px",
                    color: "black",
                    backgroundColor: "#FFF2CC",
                    border: "1px solid #e0c97f"
                }}
            >
                Save temporarily
            </Button>
        </div>


    );

}

export default ClinicalData;